import { createSectionForm } from "./sectionFormKit";

// Customer: components/sections/ChangePassword/ChangePassword.js
const ChangePassword = createSectionForm({
  icon: "lock-line",
  title: "Change Password",
  fields: [{ name: "title", label: "Heading", placeholder: "Reset Password" }],
});

export default ChangePassword;
